const PROMPT_GRADIENT = 'linear-gradient(130deg, #C5E8BA 0%, #70C481 24%, #B3EBE8 55%, #9783EA 100%)';

/**
 * Bizy prompt gradient border styling, used by `<PromptButton>` and
 * `<BizyPromptButton>` to give Bizy-related calls-to-action a consistent
 * gradient outline that swaps the inner fill on hover.
 *
 * Both modes fill the inside of the gradient border with the surface color so
 * the prompt reads as a button with only its 1px border carrying the gradient.
 * Hover swaps the inner fill to a subtly lifted background for affordance.
 */
export const promptGradientBorderSx = {
	border: '1px solid transparent',
	backgroundImage: `linear-gradient(var(--chakra-colors-bg-surface), var(--chakra-colors-bg-surface)), ${PROMPT_GRADIENT}`,
	backgroundOrigin: 'padding-box, border-box',
	backgroundClip: 'padding-box, border-box',
	'&:hover': {
		border: '1px solid transparent',
		backgroundImage: `linear-gradient(var(--chakra-colors-bg-subtle), var(--chakra-colors-bg-subtle)), ${PROMPT_GRADIENT}`,
	},
	'.chakra-ui-dark &:hover': {
		backgroundImage: `linear-gradient(var(--chakra-colors-bg-soft), var(--chakra-colors-bg-soft)), ${PROMPT_GRADIENT}`,
	},
};
